import React from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, SkeletonContent, SkeletonLine
} from '@one-thd/sui-atomic-components';
import { ShareableListCardPropTypes, ShareableListCardDefaultProps } from './utils/propTypes';

export const EmptyThumbnails = ({ numberOfThumbnails }) => (
  <div className="sui-flex sui-flex-nowrap sui-gap-2 sui-overflow-x-hidden">
    {[...Array(numberOfThumbnails)].map((item, index) => (
      <div
        key={`empty-box-${index}`}
        data-testid={`list-image-empty-${index}`}
      >
        <div className="sui-w-14 @sm:sui-w-20 @xl:sui-w-24 sui-aspect-square sui-bg-strong" />
      </div>
    ))}
  </div>
);

EmptyThumbnails.propTypes = {
  numberOfThumbnails: PropTypes.number.isRequired
};

const ShareableListCardPlaceholder = ({ numberOfThumbnails }) => (
  <Card
    data-component="ShareableListCard"
    data-testid="lists-details-placeholder"
    className="sui-w-full sui-max-w-sm"
  >
    <SkeletonContent density="loose" disablePadding initialSize="full">
      <SkeletonLine fullWidth variant="multi" numberOfLines={2} />
    </SkeletonContent>
    <CardBody>
      <EmptyThumbnails numberOfThumbnails={numberOfThumbnails + 1} />
    </CardBody>
  </Card>
);

// Using numberOfThumbnails from the shared prop types
ShareableListCardPlaceholder.propTypes = {
  numberOfThumbnails: ShareableListCardPropTypes.numberOfThumbnails
};

ShareableListCardPlaceholder.defaultProps = {
  numberOfThumbnails: ShareableListCardDefaultProps.numberOfThumbnails
};

export default ShareableListCardPlaceholder;